<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="flex min-h-dvh items-center justify-center bg-muted p-4">
        <div class="w-full max-w-sm">
            <div class="mb-6 flex items-center justify-center gap-2">
                <UIcon name="i-lucide-hotel" class="size-7 text-primary" />
                <span class="text-lg font-semibold text-highlighted">
                    Imprion PMS <span class="font-normal text-muted">Housekeeping</span>
                </span>
            </div>

            <slot>
                <RouterView />
            </slot>
        </div>
    </div>
</template>

<script lang="ts" setup>
</script>
